import { render } from "./Contractors.vue?vue&type=template&id=6ec3ecf2"
import script from "./Contractors.vue?vue&type=script&lang=js"
export * from "./Contractors.vue?vue&type=script&lang=js"

import "./Contractors.vue?vue&type=style&index=0&id=6ec3ecf2&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__